<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0 justify-content-end">
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary" @click="addMenuItems">{{ $t('add') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover striped :caption="$t('menuItems')" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
      <template #url="{item}">
        <td>
          {{ item.url }}
          <span v-if="item.pageStatus === 'Draft'" class="badge badge-warning ml-2" :title="$t('pageNotActive')">{{ $t('pageDraft') }}</span>
          <span v-else-if="item.pageStatus === 'Archive'" class="badge badge-danger ml-2" :title="$t('pageNotActive')">{{ $t('pageArchived') }}</span>
        </td>
      </template>
    </CTableWrapper>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from "@/controls/PaginatedTable.vue";
import SearchBar from "@/controls/SearchBar.vue";
import router from '@/router';
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import { convertToPascalCase } from "@/helpers/utils.js";
import { STATICINFOS_SERVICE } from "@/services/staticInfos.service.js";

export default {
  components: { CTableWrapper, SearchBar },
  data () {
    return {
      searchText: '',
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'position', label: i18n.t('position'), _classes: 'font-weight-bold', sortable: true },
        { key: 'label', label: i18n.t('labelMandatory').replace('*', ''), sortable: true },
        { key: 'url', label: i18n.t('url'), sortable: true },
        { key: 'isVisible', label: i18n.t('visible'), sortable: false },
      ],
      actions: [
        { key: 'view', label: i18n.t('view') },
        { key: 'remove', label: i18n.t('remove') }
      ],
      sorterValue: { column: 'position', asc: true },
      loading: false,
      slugToStatus: {},
    }
  },
  computed: {
    ...mapState('menuItems', ['getMenuItemsOutput']),
    ...mapState('menuItems', ['deleteMenuItemOutput']),
    menuItemsInfo: function() {
      return this.getMenuItemsOutput ? this.getMenuItemsOutput : null;
    },
    items: function()
    {
      if (!this.menuItemsInfo || !this.menuItemsInfo.data) return [];
      var slugToStatus = this.slugToStatus;
      return this.menuItemsInfo.data.map(function(item) {
        var slug = (item.url || '').replace(/^\//, '');
        return Object.assign({}, item, {
          pageStatus: slug ? (slugToStatus[slug] || null) : null
        });
      });
    },
    pages: function()
    {
      return this.menuItemsInfo ? this.menuItemsInfo.totalPages : 1;
    }
  },
  mounted: function()
  {
    this.updateItemsRequested(1, this.itemsPerPage);
    this.loadStaticPagesStatus();
  },
  methods: {
    ...mapActions('menuItems', ['getMenuItems']),
    ...mapActions('menuItems', ['deleteMenuItem']),
    rowClicked (item, index) {
      this.$router.push({name: "MenuItemsEdit", query: { id: item.id } });
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        {
          this.$router.push({name: "MenuItemsEdit", query: { id: item.id } });
          break;
        }
        case 'remove':
        {
          if(confirm(this.$i18n.tc('confirmRemove', item.label, { name: item.label }))){
            this.deleteMenuItem(item.id);
          }
          break;
        }
        default:
        {
          throw "The provided action is not supported!";
        }
      }
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {
      //Make request
      this.loading = true;
      this.itemsPerPage = itemsPerPage;

      var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));

      this.getMenuItems(input);
    },
    addMenuItems ()
    {
      router.push({ name: 'MenuItemsAdd' });
    },
    loadStaticPagesStatus()
    {
      var statuses = ['Active', 'Draft', 'Archive'];
      var requests = statuses.map(function(status) {
        var input = new InputGetList(100, 1, '', 1, 'Id');
        input.status = status;
        return STATICINFOS_SERVICE.getStaticInfos(input);
      });

      Promise.all(requests).then((results) => {
        var map = {};
        results.forEach(function(result, index) {
          var status = statuses[index];
          var pages = (result && result.data && result.data.staticInfos) || [];
          pages.forEach(function(p) {
            if (p.slug) map[p.slug] = status;
          });
        });
        this.slugToStatus = map;
      });
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    }
  },
  watch:
  {
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    deleteMenuItemOutput: function(val)
    {
      this.loading = true;

      if(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    getMenuItemsOutput: function(val)
    {
      if(val != null)
      {
        this.loading = false;
      }
    }
  }
}
</script>


<style>
th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

.status-button
{
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}
</style>